import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminGuard } from './services/admin.guard';
import { LoginComponent } from './login/login.component';
import { CategoryComponent } from './category/category.component';
import { CutFlowerStockComponent } from './cut-flower-stock/cut-flower-stock.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: HomeComponent,
    canActivate: [AdminGuard],
  },
  { path: 'category', component: CategoryComponent, canActivate: [AdminGuard] },
  { path: 'cut-flower-stock', component: CutFlowerStockComponent, canActivate: [AdminGuard] },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
